export async function fetchLocstrings(url: string): Promise<Record<string, string>> {
    let responseClone: Response;
    try {
        const response = await fetch(url);
        responseClone = response.clone();
        return await response.json();
    } catch (err) {
        let responseBody: string = 'UNKNOWN';
        if (responseClone) {
            try {
                responseBody = await responseClone.text();
            } catch (innerErr) {}
        }
        const error: Error & {
            diagnosticInfo?: string;
            knownError?: boolean;
            request?: string;
        } = new Error('Failed to load localized strings');
        error.diagnosticInfo = `${url}".\n Status: ${(responseClone && responseClone.status) ||
            'UNKNOWN'}.\n Inner error: ${err}\n Response Body: ${responseBody}`;

        if (!responseClone) {
            // Add the request url as a `request` property on the error, to signify to LazyModule
            // that this is not an eval error
            error.request = url;

            // If there was no response, it means it was a network error. In this case, mark the error as
            // a known error, since there's no actionable bug to fix or investigate
            error.knownError = true;
        }

        throw error;
    }
}
